import { useCallback, useEffect, useState } from "react";

// Grow diary shared by the Diario tab and the irrigation calendar (saved per browser).
// Waterings ticked in the calendar are diary entries with source "riego".
const KEY = "jungle-diary";
const EVT = "jungle-diary";

const load = () => {
  try { const v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch { return []; }
};

export const useDiary = () => {
  const [rows, setRowsState] = useState(load);
  useEffect(() => {
    const on = (e) => setRowsState(e.detail);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const setRows = useCallback((fn) => setRowsState((cur) => {
    const next = (typeof fn === "function" ? fn(cur) : fn).slice().sort((a, b) => b.date.localeCompare(a.date));
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* storage blocked */ }
    setTimeout(() => window.dispatchEvent(new CustomEvent(EVT, { detail: next })), 0);
    return next;
  }), []);
  return [rows, setRows];
};
